<template>

    <v-card class="elevation-12" id="register">
        <v-toolbar dark color="secondary">
            <v-btn text icon @click="back"><v-icon>keyboard_arrow_left</v-icon></v-btn>
            <v-toolbar-title>{{trans('auth-pages.register.title')}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>

            <v-alert
                    v-if="error"
                    type="error"
                    >{{error}}
            </v-alert>
            <v-form
                ref="form"
                @submit.prevent
                v-model="validForm"
                >
                <v-text-field
                        prepend-icon="person"
                        name="name"
                        :label="trans('auth-pages.register.labels.username')"
                        type="text"
                        v-model="name"
                        :required="true"

                        :error-messages="fieldErrors.username"
                        @input="resetError('name')"
                ></v-text-field>

                <v-text-field
                        prepend-icon="email"
                        name="email"
                        type="email"
                        :label="trans('auth-pages.register.labels.email')"
                        :rules="emailRules"
                        :required="true"

                        :error-messages="fieldErrors.email"
                        @input="resetError('email')"
                        v-model="email"
                        ></v-text-field>

                <v-text-field
                        prepend-icon="lock"
                        name="password"
                        :label="trans('auth-pages.register.labels.password')"
                        type="password"
                        v-model="password"
                        required
                        :rules="passwordRules"

                        :error-messages="fieldErrors.password"
                        @input="resetError('password')"

                ></v-text-field>


                <v-text-field
                        prepend-icon="lock"
                        ref="confirm"
                        name="password_confirmation"
                        :label="trans('auth-pages.reset.labels.password_confirmation')"
                        type="password"
                        v-model="password_confirmation"
                        required
                        :rules="passwordConfirmRules"

                    ></v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions>

            <v-spacer></v-spacer>
            <v-btn
                    :disabled="!validForm"
                    color="primary"
                    @click="submit"
                    ><v-icon left>send</v-icon>{{trans('auth-pages.register.submit')}}</v-btn>

            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>
<script>
    export default {
        name: "register",
        props: {
            minPasswordLength:{type:Number,required:false,default:3},
            action:{type:String,default:'/register'},
        },
        data() {
            return {
                email:'',
                name:'',
                password:'',
                password_confirmation:'',
                remember:false,

                emailRules:[v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)||'invalid email'],
                passwordRules:[v => v.length>=this.minPasswordLength||'  '],
                passwordConfirmRules:[v => v===this.password||'Password does not match'],


                validForm:false,

                error:null,

                fieldErrors:{},
            }
        },
        mounted() {},
        computed: {},
        methods: {

            back(){
                this.$emit('back')
            },
            submit(){

                let data ={
                    name    : this.name,
                    email   : this.email ,
                    password: this.password ,
                    password_confirmation : this.password_confirmation,
                };


                axios.post(this.action,data)
                    .then(r=>{
                        let redirect = (r.data && r.data.redirect)?r.data.redirect:r.request.responseURL;

                        this.$emit('registered',{response:r,redirect})
                    })
                    .catch(e=>{
                        console.error(e);
                        if(e.response){
                            if(e.response.data){
                                console.log({e});
                                if(e.response.status===422){
                                    this.fieldErrors = e.response.data.errors;
                                }

                                this.error = e.response.data.message;
                            }
                            else{
                                this.error=e.response;
                            }
                        }else{
                            this.error=e;
                        }
                    })
            },

            resetError(field){
                this.fieldErrors[field]=[];
                this.error=null
            },
        },

        components: {},
        filters: {}
    }
</script>
